import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import userFilter from "../../../hooks/filter/useFilter";
import { useSearchParams } from "react-router-dom";
import { uniqueFromArray, excludeFromArrayNumber } from "../../../utils/Functions";
import { ProjectTypeType } from "../../../interfaces/project";
import { getPropertyTypes } from "../../../data/api";

export const FilterPropertyType = ({projectTypesList}:{projectTypesList:ProjectTypeType[]}) => {
  const propertyTypes = getPropertyTypes();
  const { setFilter } = userFilter();
  const [searchParams] = useSearchParams();
  const [currentPropertyType, setCurrentPropertyType] = useState(
    [] as ProjectTypeType[]
  );

  useEffect(() => {
    const parameter = searchParams.get("propertyType");
    setCurrentPropertyType(
      !!parameter
        ? projectTypesList.filter((t) => parameter.split(",").includes(t.id.toString()))
        : ([] as ProjectTypeType[])
    );
  }, [searchParams]);
  
  return (
    <Form>
      {projectTypesList?.map((type) => (
        <div key={`filter-${type.name}`} className="mb-1">
          <label className="d-inline-flex w-100">
            <Form.Check
              className="me-2"
              type="checkbox"
              value={type.id}
              checked={currentPropertyType.includes(type) ?? false}
              onChange={(e) => {
                const current = currentPropertyType?.map((c) => c.id) ?? [];
                setFilter({
                  propertyType: e.target.checked
                    ? (uniqueFromArray([
                      ...current,
                      type.id,
                    ]) as unknown as number[])
                    : (excludeFromArrayNumber(current, type.id) as unknown as number[]),
                });
              }}
            />
            {type.name}
          </label>
        </div>
      ))}
    </Form>
  );
};
